<template>
    <div class="participant-merge mb-3 mt-page">

        <h1>{{ $i18n.gt('HEADING_MERGE_PARTICIPANTS') }}</h1>

        <b-row class="justify-content-center">
            <b-col cols="8" col-offset="2">
                <b-form-group horizontal
                              label-cols="4"
                              :label="$i18n.gt('LABEL_MERGE_THIS_PARTICIPANT')">
                    <vue-bootstrap-typeahead :data="donors"
                                             v-model="donorSearch"
                                             :placeholder="$i18n.gt('LABEL_SEARCH_BY_EMAIL')"
                                             :serializer="p => describeParticipant(p)"
                                             @hit="donor = $event">
                    </vue-bootstrap-typeahead>
                    <b-badge class="mt-2"
                             v-if="donor.id && donor.surveys">
                        {{ $i18n.gt('LABEL_SURVEYS') }}: {{ donor.surveys.length }}
                    </b-badge>
                    <div v-if="donor.id && donor.surveys && donor.surveys.length == 0">
                        <b-form-checkbox v-model="deleteDonor"
                                         :value="1">
                            {{ $i18n.gt('LABEL_DELETE') }} #{{ donor.id }} {{ $i18n.gt('LABEL_AFTER_MERGE') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
                <b-form-group horizontal
                              label-cols="4"
                              :label="$i18n.gt('LABEL_INTO_THIS_PARTICIPANT')">
                    <vue-bootstrap-typeahead :data="recipients"
                                             v-model="recipientSearch"
                                             :placeholder="$i18n.gt('LABEL_SEARCH_BY_EMAIL')"
                                             :serializer="p => `#${p.id} ${p.email} ${p.fullname} ${p.dob}`"
                                             @hit="recipient = $event">
                    </vue-bootstrap-typeahead>
                    <b-badge class="mt-2"
                             v-if="recipient.id && recipient.surveys">
                        {{ $i18n.gt('LABEL_SURVEYS') }}: {{ recipient.surveys.length }}
                    </b-badge>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="8" col-offset="2" class="text-center"
                   v-if="donor.id && recipient.id">
                <b-btn variant="primary" size="lg" class="my-4"
                       @click="merge">
                    {{ $i18n.gt('LABEL_MERGE') }}
                </b-btn>
            </b-col>
        </b-row>

    </div>
</template>

<script>

import Vue from 'vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import * as _ from 'lodash'

/**
 * Page to merge two selected Participants
 */
export default Vue.extend({
    name: "ParticipantMerge",
    components: {
        VueBootstrapTypeahead
    },
    data() {
        return {
            donors: [],
            recipients: [],
            donorSearch: '',
            recipientSearch: '',
            donor: {},
            recipient: {},
            deleteDonor: false,
        }
    },
    methods: {
        describeParticipant(p) {
            return `#${p.id} ${p.email} ${p.fullname} ${p.dob}`
        },
        async getDonors(query) {
            this.donors = await this.$api.findParticipants(this, query, ['surveys'])
        },
        async getRecipients(query) {
            this.recipients = await this.$api.findParticipants(this, query, ['surveys'])
        },
        async merge() {
            if (await this.$bvModal.msgBoxConfirm('Merge Participants?')) {
                try {
                    await this.$api.mergeParticipants(this, this.donor.id, this.recipient.id, this.deleteDonor)
                    this.$toasted.show('Participants merged', {duration: 3000})
                    this.$router.replace('/')
                } catch (e) {
                    this.$utils.handleError(e, 'Error merging participants')
                }
            }
        },
    },
    watch: {
        donorSearch: _.debounce(function (email) {
            this.getDonors(email)
        }, 500),

        recipientSearch: _.debounce(function (email) {
            this.getRecipients(email)
        }, 500)
    }

})

</script>
